import React from 'react'
import FieldError from './FieldError'

function InputElement(
    {
        handleChange,
        handleBlur,
        value,
        handleFocus,
        labelError,
        handleKeyUp,
        labelTouched,
        name,
        label,
        placeholder,
        labelStyle,
        ignoreLabel = false
    }
) {
  return (
    <div>
      {!ignoreLabel && (
        <label htmlFor="fname" className={"block font-semibold flex-1 ml-1 mt-2 text-xs lg:text-sm leading-6 text-navy font-plexsans" + labelStyle }>
          {label}
        </label>
      )}
      <div className="mt-2 w-full">
        <input
                type="text"
                name={name}
                className={"block w-full rounded-md border border-gray-200 bg-white py-2.5 pl-3 pr-10 text-navy focus:outline-none focus:border-tan focus:ring-1 focus:ring-tan placeholder:text-gray-400 text-xs lg:text-sm sm:leading-6 font-plexsans transition-colors"  + (labelError && labelTouched ? " border-red-400 focus:border-red-500 focus:ring-red-500" : "" )}
                placeholder={placeholder}
                onChange={handleChange}
                onBlur={handleBlur}
                value = {value}
                onFocus={handleFocus}
                onKeyUp={handleKeyUp}
            />
          </div>
          {labelError && labelTouched ? <FieldError>{labelError}</FieldError> : ""}
    </div>
  )
}

export default InputElement